module.exports = __webpack_public_path__ + "img/ott-home.7ea4c98b.jpg";